//Importing components
import ProductDetails from "./components/productDetails/productDetails";
import RegisteredUsers from "./components/registeredUsers/registeredUsers";
import AdminListing from "./components/adminListing/adminListing";
import CMS_Pages from "./components/cmsPages/cmsPages";
import MyBiddingListing from "./components/myBiddingLIstings/myBiddingLlisting";
import PostNewListing from "./components/postNewListing/postNewListing";
import NewProductForm from "./components/newProductForm/newProductForm";
import SearchResult1 from "./components/searchResult/searchResult1/searchResult1";
import SearchResult2 from "./components/searchResult/searchResult2/searchResult2";
import SearchResult3 from "./components/searchResult/searchResult3/searchResult3";
import Home from "./components/home/home";
import Login from "./components/login/login";
import CreateNewPwd from "./components/createNewPwd/createNewPwd";
import ForgotPassword from "./components/forgotPassword/forgotPassword";
import MailSent from "./components/mailSent/mailSent";
import SignUp from "./components/signUp/signUp";
import CategoryListing from "./components/categoryListing/categoryListing";
import SubCategoryListing from "./components/subCategoryList/subCategoryList";
import Settings from "./components/settings/settings";
import DashboardComponent from "./components/dashboard/dashboard";
import UserDashboardComponent from "./components/userDashboard/userDashboard";
import UserSettings from "./components/userSettings/userSettings";
import AboutPage from "./components/aboutPage/aboutPage";
import HelpFaq from "./components/helpFaq/helpFaq";
import Contact from "./components/contact/contact";
import UserListing from "./components/userListing/userListing";

//Importing shared components
import Error from "./shared/components/error/error";

//Importing layouts
import Default from "./layouts/default/default";
import UserDashboard from "./layouts/userDashboard/userDashboard";
import Unauth from "./layouts/unauth/unauth";
import Dashboard from "./layouts/dashboard/dashboard";
import NewPageForm from "./components/newPageForm/newPageForm";
import CMS_HelpFaq from "./components/cmsHelpFaq/cmsHelpFaq";
import NewHelpFaqForm from "./components/newHelpFaqForm/newHelpFaqForm";
import EmailTemplates_CMS from "./components/cmsEmailTemplates/cmsEmailTemplates";
import NewEmailTemplateForm from "./components/newEmailTemplateForm/newEmailTemplateForm";
import Page_CMS from "./shared/components/cmsPage/cmsPage";
import ContactUsQueries from "./components/contactUsQueries/contactUsQueries";
import EditQueryStatusForm from "./components/editQueryStatusForm/editQueryStatusForm";

const routes = [
  {
    path: "/",
    access: true,
    exact: true,
    name: "Home",
    layout: Default,
    component: Home,
  },
  {
    path: "/cms/:slug",
    access: true,
    exact: true,
    name: "CMS_Page",
    layout: Default,
    component: Page_CMS,
  },
  {
    path: "/search-result",
    access: true,
    exact: true,
    name: "SearchResult",
    layout: Default,
    component: SearchResult2,
  },
  {
    path: "/search-result/1",
    access: true,
    exact: true,
    name: "SearchResult1",
    layout: Default,
    component: SearchResult1,
  },
  {
    path: "/search-result/2",
    access: true,
    exact: true,
    name: "SearchResult2",
    layout: Default,
    component: SearchResult2,
  },
  {
    path: "/search-result/3",
    access: true,
    exact: true,
    name: "SearchResult3",
    layout: Default,
    component: SearchResult3,
  },
  {
    path: "/contact-us",
    access: true,
    exact: true,
    name: "Contact Us",
    layout: Default,
    component: Contact,
  },
  {
    path: "/help",
    access: true,
    exact: true,
    name: "HelpFaq",
    layout: Default,
    component: HelpFaq,
  },
  {
    path: "/about-us",
    access: true,
    exact: true,
    name: "About Us",
    layout: Default,
    component: AboutPage,
  },
  {
    path: "/dashboard",
    access: false,
    exact: true,
    name: "Dashboard",
    role: ["admin", "user"],
    layout: Dashboard,
    component: DashboardComponent,
  },
  {
    path: "/settings",
    access: false,
    exact: true,
    name: "settings",
    role: ["admin", "user"],
    layout: Dashboard,
    component: Settings,
  },
  {
    path: "/category",
    access: false,
    exact: true,
    name: "categoryListing",
    role: ["admin"],
    layout: Dashboard,
    component: CategoryListing,
  },
  {
    path: "/sub-category",
    access: false,
    exact: true,
    name: "categoryListing",
    role: ["admin"],
    layout: Dashboard,
    component: SubCategoryListing,
  },

  {
    path: "/registered-users",
    access: false,
    exact: true,
    name: "registeredUsers",
    role: ["admin"],
    layout: Dashboard,
    component: RegisteredUsers,
  },
   {
    path: "/admin-listing",
    access: false,
    exact: true,
    name: "adminListing",
    role: ["admin"],
    layout: Dashboard,
    component: AdminListing,
  },
  {
    path: "/user-listing",
    access: false,
    exact: true,
    name: "adminListing",
    role: ["user"],
    layout: Dashboard,
    component: AdminListing,
  },
  {
    path: "/my-bids",
    access: false,
    exact: true,
    name: "bidListing",
    role: ["user"],
    layout: Dashboard,
    component: MyBiddingListing,
  },
  {
    path: "/cms-pages",
    access: false,
    exact: true,
    name: "cmsPages",
    role: ["admin"],
    layout: Dashboard,
    component: CMS_Pages,
  },
  {
    path: "/cms-help-faq",
    access: false,
    exact: true,
    name: "cmsHelpFaq",
    role: ["admin"],
    layout: Dashboard,
    component: CMS_HelpFaq,
  },
  {
    path: "/cms-email-templates",
    access: false,
    exact: true,
    name: "cmsEmailTemplates",
    role: ["admin"],
    layout: Dashboard,
    component: EmailTemplates_CMS,
  },
  {
    path: "/post-new-page/:pageId?",
    access: false,
    exact: true,
    name: "postNewPage",
    role: ["admin", "user"],
    layout: Dashboard,
    component: NewPageForm,
  },
  {
    path: "/post-new-faq/:faqId?",
    access: false,
    exact: true,
    name: "postNewFaq",
    role: ["admin"],
    layout: Dashboard,
    component: NewHelpFaqForm,
  },
  {
    path: "/post-new-email-template/:templateId?",
    access: false,
    exact: true,
    name: "postNewEmailTemplate",
    role: ["admin"],
    layout: Dashboard,
    component: NewEmailTemplateForm,
  },
  {
    path: "/edit-contact-us-query-status/:queryId",
    access: false,
    exact: true,
    name: "EditQuery",
    role: ["admin"],
    layout: Dashboard,
    component: EditQueryStatusForm,
  },
  {
    path: "/contact-us-queries",
    access: false,
    exact: true,
    name: "ContactUsQueries",
    role: ["admin"],
    layout: Dashboard,
    component: ContactUsQueries,
  },
  {
    path: "/post-new-listing",
    access: false,
    exact: true,
    name: "postNewListing",
    role: ["admin", "user"],
    layout: Dashboard,
    component: PostNewListing,
  },
  {
    path: "/edit-post-new-listing/:productId",
    access: false,
    exact: true,
    name: "editPostNewPage",
    role: ["admin", "user"],
    layout: Dashboard,
    component: PostNewListing,
  },
  {
    path: "/new-product-form/:productId?",
    access: false,
    exact: true,
    name: "newProductForm",
    role: ["admin", "user"],
    layout: Dashboard,
    component: NewProductForm,
  },
  {
    path: "/login",
    access: true,
    exact: true,
    name: "login",
    layout: Unauth,
    component: Login,
  },
  {
    path: "/create-new-pwd/:userId/:token",
    access: true,
    exact: true,
    name: "createNewPwd",
    layout: Unauth,
    component: CreateNewPwd,
  },
  {
    path: "/forgot-password",
    access: true,
    exact: true,
    name: "forgotPassword",
    layout: Unauth,
    component: ForgotPassword,
  },
  {
    path: "/mail-sent",
    access: true,
    exact: true,
    name: "mailSent",
    layout: Unauth,
    component: MailSent,
  },
  {
    path: "/sign-up",
    access: true,
    exact: true,
    name: "signUp",
    layout: Unauth,
    component: SignUp,
  },
  {
    path: "/product-details",
    access: true,
    exact: true,
    name: "productDetails",
    layout: Unauth,
    component: ProductDetails,
  },
  // {
  //   path: "/user-listing",
  //   access: true,
  //   exact: true,
  //   name: "AdminListing",
  //   layout: UserDashboard,
  //   component: UserListing,
  // },
  {
    path: "/*",
    access: true,
    exact: true,
    name: "Erorr",
    layout: Unauth,
    component: Error,
  },
];

export default routes;
